import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container, FormGroup, Breadcrumb, Navbar } from "react-bootstrap";
import { connect } from "react-redux";
import { getHotSellingReport } from "./Report.action";
import { Link } from "react-router-dom";
import _ from "lodash";
import Spinner from 'react-bootstrap/Spinner';
import Swal from 'sweetalert';
import moment from "moment";
import IconMenu from "../../../drawer/IconMenu";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const HotSellingReport = (props) => {
    const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
    const [visibleAlert, setAlertVisible] = useState(false);
    const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);


    const handleVisible = () => {
        setAlertVisible(true)
        setTimeout(() => {
            setAlertVisible(false)
        }, 9000);
        Swal({
            title: "Success",
            text: "Report Generated Successfully",
            icon: "success",
            button: "Ok",
        });
    }
    const handleDangerVisible = () => {
        setDangerVisibleAlert(true)
        setTimeout(() => {
            setDangerVisibleAlert(false)
        }, 9000);
        Swal({
            title: "Error",
            text: "Something went Wrong!",
            icon: "error",
            button: "Ok",
        });
    }
    const exportPDF = () => {
        props.getHotSellingReport({
            startDate: startDate,
            endDate: endDate
        },
            handleVisible,
            handleDangerVisible)
    }

    return (
        <>
            <Navbar style={{ backgroundColor: '#81abd3' }}  >
                <Container>
                    <Navbar.Brand style={{ color: 'white' }}><b>Hot Selling Report</b></Navbar.Brand>
                    <IconMenu />
                </Container>
            </Navbar>

            <Container fluid>
                <div className="main">
                    <Row>
                        <Breadcrumb>
                            <Breadcrumb.Item ><Link to="/home"> Home</Link></Breadcrumb.Item>
                            <Breadcrumb.Item ><Link to="/report">Report</Link> </Breadcrumb.Item>
                            <Breadcrumb.Item active>Hot Selling Report</Breadcrumb.Item>
                        </Breadcrumb>
                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Form.Label><b>Start Date *</b></Form.Label>
                                <Form.Control
                                    type="date"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                >
                                </Form.Control>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Form.Label><b>End Date *</b></Form.Label>
                                <Form.Control
                                    type="date"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                >
                                </Form.Control>
                            </FormGroup>
                        </Col>
                    </Row>

                    <div className="sendDiv">
                        {_.isEmpty(startDate) || _.isEmpty(endDate) ? (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> Generate Report </Button>
                        ) : (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={() => exportPDF()}> Generate Report </Button>
                        )}
                    </div>

                </div>
            </Container>
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
        getHotSellingReport: (data, handleVisible, handleDangerVisible) => dispatch(getHotSellingReport(data, handleVisible, handleDangerVisible)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    hotSellingReportData: state.ReportReducer.hotSellingReportData,
    isFetchinghotSellingReport: state.ReportReducer.isFetchinghotSellingReport,
});

export default connect(mapStateToProps, mapDispatchToProps)(HotSellingReport);